import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const laneViewMapStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            position: "relative",
            height: 400,
        },

        indicatorContainer: {
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        },

        indicator: {
            width: "100%",
            height: "100%",
            padding: 100,
        },
    })
);
